import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  sectionIndent: {
    marginBottom: '42px'
  },
  inputIndent: {
    marginBottom: '24px'
  },
  participants: {
    display: 'flex',
    justifyContent: 'space-between',
    flexFlow: 'wrap',
    marginBottom: '18px'
  },
  units:{
     width: '285px'
  },
  participant: {
    width: '285px'
  },
  inputField: {
    marginBottom: '24px'
  },
  error: {
    margin: '-34px 0 35px'
  },
   errorUnit: {
    margin: '-20px 0 35px'
  }
});

export default useStyles;
